import React from 'react';
import { Form, Input, Button, message } from 'antd';
import {UserOutlined,LockOutlined} from '@ant-design/icons';
import "./login.css";
import { doLogin } from '../../model/user/requests';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import { route } from '../../routes/routes';

const FormItem = Form.Item;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };


class Login extends React.Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            isLogin: true,
            data:{
                email:"",
                passwd:""
            }
        }
    }

    componentDidMount(){
        // todo if the token saved into localstorage , jumped directly
        if (storage.check(configs.cache.tokenKey)){
            this.props.history.push(route.dashboard.index)
        }
    }

    handleSubmit=(e)=>{
        let inputEmail = this.formRef.current.getFieldValue('email');
        let inputPasswd = this.formRef.current.getFieldValue('password');
        doLogin({email:inputEmail,passwd:inputPasswd}).then(res=>{
            if(res.data.code !== 200 ){
                message.error(res.data.msg)
            }else{
                storage.set(configs.cache.tokenKey,res.data.data)
                this.props.history.push(route.dashboard.index);
            }
        }).catch(err=>{
            message.error("Login Failed")
        })
    }

    render(){
        return(
            <>
             <div className="login">
                <div className="login-form" >
                    <div className="login-logo">
                        <div className='svg'>
                        </div>
                        <div>
                        <span>KaiOS Terminal Management System</span>
                        </div>
                    </div>
                    <Form 
                        onFinish={this.handleSubmit} 
                        layout={layout}
                        ref={this.formRef}
                        name="control-ref"
                    >
                        <FormItem 
                            name='email'
                            rules={[{
                                required:true
                            }]}
                    
                        >
                            <Input prefix={<UserOutlined />} placeholder="Input The Email" /> 
                        </FormItem>

                        <FormItem
                            name='password'
                            rules={[{
                                required:true,
                                message:'Please input the password !'
                            }]}
                        >
                                <Input.Password prefix={<LockOutlined />} placeholder="Input The Password" />
                        </FormItem>
                        <FormItem>
                            <Button 
                                type="primary"
                                htmlType="submit"
                                className="login-form-button" 
                                style={{background: "#851dd6",color:"white",width:"100%" }}
                
                               >
                                    Login
                            </Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
            </>
        )
    }
}

export default Login;



